import { isEmpty } from '../../../../utils/common'
import { validPhone, validPassword } from '../../../../utils/reg'

export const statusOptions = [
	{
		label: '正常',
		value: 1
	},
	{
		label: '停止登录',
		value: 2
	}
]

export const renderList = [
	{
		label: '账户名称',
		key: 'name',
		type: 'input',
		placeholder: '请输入'
	}
]

export const renderMobileList = [
	{
		label: '账户名称',
		key: 'name',
		type: 'input',
		placeholder: '请输入'
	}
]

export const formRenderList = [
	{
		label: '账号名称',
		type: 'input',
		placeholder: '请输入账号名称',
		key: 'name',
		maxLength: 50,
		require: true
	},
	{
		label: '登录账号',
		type: 'input',
		placeholder: '请输入邮箱',
		key: 'email',
		maxLength: 50,
		require: true
	},
	{
		label: '登录密码',
		type: 'input',
		placeholder: '请输入密码',
		key: 'password',
		maxLength: 16,
		require: true
	},
	{
		label: '所属客户',
		type: 'select',
		placeholder: '请选择所属客户',
		key: 'customerId',
		options: [],
		require: true
	},
	{
		label: '账号角色',
		type: 'select',
		placeholder: '请选择账号角色',
		key: 'userRoleId',
		options: [
			{
				label: '数据',
				value: 3
			}
		],
		require: true
	},
	{
		label: '状态',
		type: 'select',
		placeholder: '请选择状态',
		key: 'status',
		options: statusOptions,
		require: true
	},
	{
		label: '手机号',
		type: 'input',
		inputType: 'number',
		placeholder: '请输入手机号',
		key: 'phone',
		maxLength: 11,
		require: true
	},
	{
		label: '备注',
		type: 'textarea',
		placeholder: '请输入备注',
		key: 'notes',
		maxLength: 100,
		require: true
	},
]

export const formRules = {
	name: [
		{ required: true, message: '请输入账号名称', trigger: 'blur' }
	],
	email: [
		{ required: true, message: '请输入邮箱', trigger: 'blur' },
		{ type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
	],
	password: [
		{ required: true, message: '请输入密码', trigger: 'blur' },
		{
			validator: function (rule, value, callback) {
				if (validPassword(value)) {
					callback()
				} else {
					callback(new Error('密码限制6-16位非中文字符'));
				}
			}, trigger: 'blur'
		}
	],
	customerId: [
		{ required: true, message: '请选择所属客户', trigger: 'blur', type: 'number' }
	],
	userRoleId: [
		{ required: true, message: '请选择账号角色', trigger: 'blur', type: 'number' }
	],
	status: [
		{ required: true, message: '请选择状态', trigger: 'blur', type: 'number' }
	],
	phone: [
		{
			validator: function (rule, value, callback) {
				if (isEmpty(value)) {
					callback()
				} else {
					if (validPhone(value)) {
						callback()
					} else {
						callback(new Error('请输入正确的手机号'));
					}
				}
			}, trigger: 'blur'
		}
	],
	notes: [
		{ required: false, message: '姓名不能为空', trigger: 'blur' }
	]

}


// WEBPACK FOOTER //
// ./src/pages/home/userInfo/accountManage/config.js